import { RootDispatch, RootGetState } from "../types";
import { VideoChatInviteMode } from "./types";
import history from "../../history";
import { post, get } from "../../utils/fetch";

export const VIDEOCHAT_FETCH_CONSENT_MESSAGE = "videoChat/fetch-consent-message";
export const VIDEOCHAT_FETCHED_CONSENT_MESSAGE = "videoChat/fetched-consent-message";
export const VIDEOCHAT_FETCH_CONSENT_MESSAGE_ERROR = "videoChat/fetch-consent-message-error";
export const VIDEOCHAT_CONSENT_ACKNOWLEDGED = "videoChat/consent-acknowledged";
interface FetchConsentMessageAction {
  type: typeof VIDEOCHAT_FETCH_CONSENT_MESSAGE;
}
interface FetchedConsentMessageAction {
  type: typeof VIDEOCHAT_FETCHED_CONSENT_MESSAGE;
  consentMessage: string | null;
}
interface FetchConsentMessageErrorAction {
  type: typeof VIDEOCHAT_FETCH_CONSENT_MESSAGE_ERROR;
  errorMessage?: string;
}
interface ConsentMessageAcknowledged {
  type: typeof VIDEOCHAT_CONSENT_ACKNOWLEDGED;
}

export type Action =
  | { type: "videoChat/initiateVideoChat-started" }
  | { type: "videoChat/initiateVideoChat-success"; localParticipantUid: string }
  | { type: "videoChat/initiateVideoChat-failure" }
  | FetchConsentMessageAction
  | FetchedConsentMessageAction
  | FetchConsentMessageErrorAction
  | ConsentMessageAcknowledged;

export const initiateVideoChat = (mode: VideoChatInviteMode = VideoChatInviteMode.Sms) => async (
  dispatch: RootDispatch,
  getState: RootGetState
) => {
  dispatch({
    type: "videoChat/initiateVideoChat-started"
  });

  const url =
    "/api/organization/" +
    getState().orgs.currentOrganization?.id +
    "/patients/" +
    getState().patientdetail.data.patient?.id +
    (mode == VideoChatInviteMode.Sms ? "/secureVideo/" : "/sendVideoVisitInviteEmail/");

  const resp = await post<{ providerUid: string }>(url, {});

  if (resp.error) {
    dispatch({
      type: "videoChat/initiateVideoChat-failure",
      error: resp.error.message
    });
  } else if (resp.data) {
    dispatch({
      type: "videoChat/initiateVideoChat-success",
      localParticipantUid: resp.data.providerUid
    });
    history.push(`/video_chat/${resp.data.providerUid}`);
  }
};

interface ConsentMessageResponse {
  consentMessage: string;
}
export const fetchConsentMessage = (participantUid: string) => async (dispatch: RootDispatch) => {
  dispatch({
    type: VIDEOCHAT_FETCH_CONSENT_MESSAGE
  });
  const url = `/api/conferencing/video/consent/${participantUid}/`;
  try {
    const resp = await get<ConsentMessageResponse>(url);
    dispatch({
      type: VIDEOCHAT_FETCHED_CONSENT_MESSAGE,
      consentMessage: resp?.data?.consentMessage || ""
    });
  } catch (error) {
    if (!error?.response?.status || error.response.status >= 400) {
      dispatch({ type: VIDEOCHAT_FETCH_CONSENT_MESSAGE_ERROR, errorMessage: error?.message });
    }
  }
};
